import * as React from 'react';
import { UnifyStyleContextProvider } from 'src/styles/context/unifyStyleContext';

/**
 * A Theme utility provider that can be used to wrap UI roots that should
 * render using a modern Unify theme when nested inside legacy WSD theme
 * context.
 *
 * @access public
 *
 * @see WsdThemeProvider
 */
export const NestedUnifyThemeProvider: React.FC = (props) => {
  const { children } = props;

  return (
    <UnifyStyleContextProvider value={{ legacyWsdStyleSupport: false }}>
      {children}
    </UnifyStyleContextProvider>
  );
};

export default NestedUnifyThemeProvider;
